const wrappedComponent = base => props => ({
  ...base,
  props: { ...base.props, ...props },
})

export default { wrappedComponent }
